// extracted by mini-css-extract-plugin
export var alternate = "_l-j";
export var black = "_l-6";
export var blue = "_l-f";
export var blueLight = "_l-e";
export var brand = "_l-8";
export var darkMode = "_l-b";
export var error = "_l-a";
export var gray = "_l-5";
export var grayBlue = "_l-d";
export var iconWrapper = "_l-3";
export var inactive = "_l-7";
export var indigo = "_l-g";
export var orange = "_l-i";
export var pink = "_l-h";
export var primary = "_l-0";
export var purple = "_l-9";
export var success = "_l-4";
export var warning = "_l-c";
export var white = "_l-1";
export var whiteSuccess = "_l-2";